import { useEffect } from "react";
import "@sourceflow-uk/job-search/dist/bundle.css";
import ArrowRight from "@/assets/ArrowRight.svg";
import JobSearch from "@sourceflow-uk/job-search";
import PropTypes from "prop-types";
import { Container, FormCheck, Stack } from "react-bootstrap";
import { CTA } from "@/ui";
import classes from "./styles.module.scss";
import clsx from "classnames";
import { formatDistanceToNowStrict, fromUnixTime } from "date-fns";
import { trimText } from "@/functions/trimText";
import { formatSalary } from "@/functions/formatSalary";

import Branches from "@/../.sourceflow/jobs-Branches.json";
import JobType from "@/../.sourceflow/jobs-Job Type.json";
import Sector from "@/../.sourceflow/jobs-Sector.json";
import Salary from "@/../.sourceflow/jobs-Salary.json";
import WorkType from "@/../.sourceflow/jobs-Work type.json";
import EmployersType from "@/../.sourceflow/jobs-Employers.json";
import HoursType from "@/../.sourceflow/jobs-FullPart Time.json";
import { jobs_helper } from "@/helpers/jobs_helper";
import { employer_helper } from "@/helpers/employer_helper";
import { branded_job_ads } from "@/helpers/branded_job_ads";

export default function JobsFeed({
  sectionId,
  className,
  sectors = null,
  jobType = null,
  workType = null,
  branches = null,
  changeURLOnFilterChange,
}) {
  const processFilter = (value) => {
    if (typeof value === "string" && value.length > 0) {
      const items = value.split(",").map((item) => item.trim().slice(1, -1));
      return items.filter(Boolean).length > 0 ? items : null;
    }
    if (Array.isArray(value) && value.length > 0) {
      return value;
    }
    return null;
  };

  const prefilters = {};
  const processedSectors = processFilter(sectors);
  const processedBranches = processFilter(branches);

  if (processedSectors) {
    prefilters["3186657c-e89c-4a6f-9157-35eb7fe0b379"] = processedSectors;
  }
  if (jobType) {
    prefilters["275d8990-bd9e-4f79-a0e2-d81bb734c855"] = [jobType];
  }
  if (workType) {
    prefilters["1bfde1ab-62a6-4040-9c0e-5b8c59d4f6d8"] = [workType];
  }
  if (processedBranches) {
    prefilters["33b21b47-15e3-40a2-bc7b-32019e94c7ba"] = processedBranches;
  }

  useEffect(() => {
    const select = document.querySelector(".js-input-radius");
    if (!select) return;
    Array.from(select.options).forEach((option) => {
      const val = parseInt(option.value, 10);
      option.text = val === 0 ? "This area only" : `+${val} miles`;
    });
  }, []);

  return (
    <div id={sectionId} className={clsx(className, classes.feed)}>
      <Container>
        <JobSearch
          options={{
            jobsUrl: "/jobs/",
            prefilters: prefilters,
            urlFilters: {
              mode: "active",
              jobCategories: [EmployersType, Branches, Sector, JobType, Salary, WorkType, HoursType],
              changeURLOnFilterChange: changeURLOnFilterChange,
            },
            searchInput: {
              queryInput: true,
              locationInput: true,
              radiusInput: true,
              radiusOptions: {
                units: "miles",
                values: [0, 5, 10, 20, 30, 40, 50],
                default: 10,
              },
            },
            searchFiltersOptions: {
              filterUnselectedElement: <FormCheck />,
              filterSelectedElement: <FormCheck checked />,
              exclude: {
                "af83ff7d-ff72-43c0-aba5-ccac084aec2d": true,
                "33b21b47-15e3-40a2-bc7b-32019e94c7ba": [
                  "be80efef-220b-4d55-92f9-740785808af9",
                  "7106a96e-cb09-458d-b121-6d8ecaa75d18",
                ],
                "3186657c-e89c-4a6f-9157-35eb7fe0b379": [sectors],
              },
              categorySort: {
                Branches: { key: "name", direction: "asc" },
                Sector: { key: "name", direction: "asc" },
                Salary: { key: "name", direction: "asc" },
                "Work type": function (a, b) {
                  if (a.name < b.name) {
                    return -1;
                  } else if (a.name > b.name) {
                    return 1;
                  } else {
                    return 0;
                  }
                },
                "Job Type": function (a, b) {
                  if (a.name < b.name) {
                    return -1;
                  } else if (a.name > b.name) {
                    return 1;
                  } else {
                    return 0;
                  }
                },
              },
            },
            searchResultsOptions: {
              resultNewTab: false,
              resultCategories: {
                Salary: false,
                Branches: false,
              },
            },
            searchResults: ({ results }) =>
              results?.length >= 1 ? (
                <>
                  {results.map(({ job, index }) => {
                    let logo = null;

                    const [employerID] = jobs_helper.getCategoryValueIds("1df83e15-03f4-4ce7-9f8d-9b20d0ea1538", job);
                    const [brandID] = jobs_helper.getCategoryValueIds("2af5dce1-01c9-4f09-9fcd-470dfef8cebb", job);
                    if (employerID) {
                      const employer = employer_helper.find(employerID, "id");
                      if (employer) {
                        if ("logo" in employer) {
                          logo = employer.logo;
                        }
                      }
                    } else if (brandID) {
                      const brand = branded_job_ads.find(brandID, "id");
                      if (brand) {
                        if ("logo" in brand) {
                          logo = brand.logo;
                        }
                      }
                    }

                    let employers = job.categories
                      ?.map(
                        (cat) =>
                          cat.id == "1df83e15-03f4-4ce7-9f8d-9b20d0ea1538" &&
                          cat.values?.map((value) => (
                            <>
                              <span class="js-results-category-value">{value.name}</span>
                            </>
                          )),
                      )
                      .filter(Boolean);
                    let fullPartTime = job.categories
                      ?.map(
                        (cat) =>
                          cat.id == "f2bec422-3deb-4111-ab36-89cb892e33a6" &&
                          cat.values?.map((value) => (
                            <>
                              <span class="js-results-category-value">{value.name}</span>
                            </>
                          )),
                      )
                      .filter(Boolean);
                    let sector = job.categories
                      ?.map(
                        (cat) =>
                          cat.id == "3186657c-e89c-4a6f-9157-35eb7fe0b379" &&
                          cat.values?.map((value) => (
                            <>
                              <span class="js-results-category-value">{value.name}</span>
                            </>
                          )),
                      )
                      .filter(Boolean);
                    let jobType = job.categories
                      ?.map(
                        (cat) =>
                          cat.id == "275d8990-bd9e-4f79-a0e2-d81bb734c855" &&
                          cat.values?.map((value) => (
                            <>
                              <span class="js-results-category-value">{value.name}</span>
                            </>
                          )),
                      )
                      .filter(Boolean);
                    let workType = job.categories
                      ?.map(
                        (cat) =>
                          cat.id == "1bfde1ab-62a6-4040-9c0e-5b8c59d4f6d8" &&
                          cat.values?.map((value) => (
                            <>
                              <span class="js-results-category-value">{value.name}</span>
                            </>
                          )),
                      )
                      .filter(Boolean);

                    return (
                      <div key={index} class="js-result js-panel-border">
                        <div class={`js-result-title ${logo ? "has-logo" : ""}`}>
                          <a href={`/jobs/${job.url_slug}/`}>{job.title}</a>
                        </div>
                        <div class="js-result-details">
                          {job.addresses && <div class="js-results-details-location">{job.addresses}</div>}
                          {job.salary_package && (
                            <div class="js-results-details-salary-package">{formatSalary(job.salary_package)}</div>
                          )}
                          <div class="js-results-details-categories">
                            {employers.length > 0 && <div class="js-results-details-category">{employers}</div>}
                            {fullPartTime.length > 0 && <div class="js-results-details-category">{fullPartTime}</div>}
                            {sector.length > 0 && <div class="js-results-details-category">{sector}</div>}
                            {jobType.length > 0 && <div class="js-results-details-category">{jobType}</div>}
                            {workType.length > 0 && <div class="js-results-details-category">{workType}</div>}
                          </div>
                        </div>
                        {job.description && (
                          <div
                            class="js-result-description"
                            dangerouslySetInnerHTML={{ __html: trimText(job.description, 300) }}
                          />
                        )}
                        <div class="js-result-links">
                          {logo && <img className="js-results-details-employer-logo" src={logo} alt="" />}
                          <time className="me-auto">{`Posted ${formatDistanceToNowStrict(
                            fromUnixTime(job.published_at),
                          )} ago`}</time>
                          <CTA href={`/jobs/${job.url_slug}/`} label="View job" variant="secondary" />
                          <CTA href={`/jobs/${job.url_slug}/#Apply`} label="Apply now" variant="outline-secondary" />
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <>
                  {/* <p>
                    Sorry, we couldn't find any jobs matching your search. Please try removing some filters or searching
                    for something else.
                  </p> */}
                  <>
                    <p>
                      <b>Sorry, we can’t find any roles that match your search right now.</b>
                      <br />
                      Tell us a bit about the kind of work you’re looking for, and we’ll use your feedback to improve
                      the jobs we show you.
                    </p>

                    {/* Leadoo Form */}
                    <iframe
                      src="https://bot.leadoo.com/bot/visual.html?code=86ns8t919ilm4aby"
                      style={{ border: "none" }}
                      width="100%"
                      height="450"
                      title="Leadoo Form"
                    />

                    {/* Banner */}
                    <div className="mt-4 p-4 text-center js-panel-border">
                      <h5>Need more help with your job search?</h5>
                      <p>Contact your local branch to speak with one of our recruitment advisors</p>
                      <CTA href="/our-branches/" label="Find your local branch" variant="primary" />
                    </div>
                  </>
                </>
              ),
          }}
          translations={{
            "searchResults.buttonText": "View job",
            "button.text": (
              <Stack className="flex-row align-items-center justify-content-center px-3" gap={2}>
                Search <ArrowRight />
              </Stack>
            ),
          }}
        />
      </Container>
    </div>
  );
}

JobsFeed.defaultProps = {
  className: "py-4 py-md-5",
  sectors: null,
  changeURLOnFilterChange: false,
};

JobsFeed.propTypes = {
  className: PropTypes.string,
  sectors: PropTypes.string,
};
